import React from "react";
import { Path, Defs, LinearGradient, Stop, G } from "react-native-svg";

export default function QuestionMarkIcon(props) {
  const size = 26;
  const offset = size / 2;

  return (
    <G
      x={props.x - offset}
      y={props.y - offset}
      width={size}
      height={size}
      fill="none"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="url(#q_paint0_linear)"
      />
      <Path
        d="M8.26599 9.19727C8.27536 8.65472 8.44155 8.12647 8.74451 7.67628C9.0933 7.13752 9.57623 6.69876 10.1459 6.40308C10.8098 6.05659 11.5504 5.88319 12.2992 5.89893C12.9952 5.88596 13.6849 6.03209 14.3158 6.32618C14.8649 6.57271 15.333 6.9697 15.6659 7.4712C15.9823 7.93406 16.1494 8.48279 16.1444 9.04346C16.1562 9.45351 16.062 9.85967 15.871 10.2227C15.6997 10.5369 15.4838 10.8247 15.2301 11.0772C14.9823 11.3164 14.5294 11.7266 13.88 12.3076C13.7091 12.47 13.5638 12.6152 13.4528 12.7349C13.3619 12.8406 13.2818 12.9551 13.2135 13.0767C13.1626 13.1746 13.1225 13.2777 13.0939 13.3843C13.0939 13.4868 13.017 13.6663 12.9572 13.9226C12.9576 14.0416 12.9333 14.1594 12.8856 14.2684C12.8379 14.3774 12.768 14.4753 12.6803 14.5557C12.5927 14.6362 12.4891 14.6974 12.3764 14.7355C12.2637 14.7737 12.1443 14.7878 12.0258 14.7771C11.8986 14.7812 11.7719 14.7599 11.653 14.7144C11.5342 14.6689 11.4256 14.6002 11.3336 14.5122C11.2343 14.4064 11.158 14.2812 11.1094 14.1444C11.0609 14.0076 11.0412 13.8623 11.0516 13.7175C11.0389 13.3146 11.1087 12.9133 11.2567 12.5383C11.386 12.2229 11.5713 11.9334 11.8036 11.6838C12.0911 11.3811 12.3964 11.0957 12.7179 10.8294C13.0511 10.5303 13.299 10.3081 13.4442 10.1628C13.5961 10.0164 13.7231 9.84608 13.8202 9.6587C13.9255 9.47689 13.9815 9.27068 13.9825 9.06055C13.9849 8.86055 13.9441 8.66239 13.863 8.47956C13.7819 8.29672 13.6624 8.1335 13.5126 8.00098C13.1805 7.70288 12.745 7.54647 12.2992 7.56519C12.0683 7.54424 11.8355 7.57223 11.6161 7.64732C11.3967 7.72241 11.1957 7.84292 11.026 8.00098C10.7017 8.37524 10.4627 8.81549 10.3253 9.29127C10.1459 9.88087 9.81262 10.1458 9.30847 10.1458C9.17015 10.1477 9.03288 10.1215 8.90505 10.0686C8.77722 10.0157 8.66154 9.93729 8.56506 9.83814C8.38648 9.67106 8.27933 9.44146 8.26599 9.19727ZM12.1112 17.8362C11.7977 17.8455 11.4923 17.7356 11.2567 17.5286C11.0313 17.3013 10.9048 16.9942 10.9048 16.6741C10.9048 16.354 11.0313 16.0468 11.2567 15.8196C11.3681 15.707 11.5014 15.6186 11.6484 15.5598C11.7954 15.501 11.9529 15.4731 12.1112 15.4778C12.2697 15.4715 12.4277 15.4987 12.5749 15.5576C12.7221 15.6165 12.8553 15.7057 12.9657 15.8196C13.0776 15.931 13.165 16.0646 13.2224 16.2117C13.2797 16.3588 13.3058 16.5163 13.299 16.6741C13.3058 16.8334 13.2781 16.9923 13.2176 17.1398C13.1571 17.2873 13.0653 17.42 12.9486 17.5286C12.7196 17.7352 12.4196 17.8455 12.1112 17.8362Z"
        fill="white"
      />
      <Path
        d="M20.3069 12C20.3069 16.5878 16.5878 20.3069 12 20.3069C7.41223 20.3069 3.69312 16.5878 3.69312 12C3.69312 7.41223 7.41223 3.69312 12 3.69312C16.5878 3.69312 20.3069 7.41223 20.3069 12Z"
        stroke="white"
        strokeWidth="2.13623"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Defs>
        <LinearGradient
          id="q_paint0_linear"
          x1="0"
          y1="0"
          x2="16.8945"
          y2="19.1858"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#07FFB1" />
          <Stop offset="1" stopColor="#0FA6BF" />
        </LinearGradient>
      </Defs>
    </G>
  );
}
